<template>
    <div>
        <a-card size="small" title="模板管理">
            <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>
        </a-card>
        <channelSelecter :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter>
        <a-card size="small">
            <searchE @handleSearch="handleSubmit"></searchE>
            <tableE ref="templeteTableID"></tableE>
        </a-card>
    </div>
</template>
<script>
import tableE from './table'
import searchE from './search'
import channelSelecter from '../components/channelSelecter'

export default {
    data() {
        return {
            channelcode:'',
            searchP:{
                keyword:'',
                passwaytype:'',
                channelcode:'',
            }
        };
    },
    methods: {
        handleChannelChange(item){
            this.channelcode = item.value;
            this.searchP.channelcode = item.value;
            this.$refs.templeteTableID.handleSearch(this.searchP);

        },
        handleSubmit(searchP){
            this.searchP = searchP;
            searchP.channelcode = this.channelcode;
            this.$refs.templeteTableID.handleSearch(this.searchP);
        },

        handleNew(){
            this.$router.push({
                path: "add_templete",
                query: {id:''}
            });
        }
    },
    components:{
        tableE,
        searchE,
        channelSelecter
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
